import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

class MedicineReport extends Component {
  constructor(props) {
    super(props);

    this.state = { medicine: [], spinnerClass: "", dataClass: "collapse" };
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/medicine/reportThreshold"
      )
      .then(response => {
        this.setState({
          medicine: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  tabRow() {
    return this.state.medicine.map(function(obj) {
      // if (
      //   obj._id.expDate !== null &&
      //   obj._id.expDate !== "" &&
      //   obj._id.expDate !== undefined
      // ) {
      //   var arrExpDate = obj._id.expDate.split("-");
      //   var expdate =
      //     arrExpDate[2].substring(0, 2) +
      //     "-" +
      //     arrExpDate[1] +
      //     "-" +
      //     arrExpDate[0];
      // }

      return (
        <tr key={obj._id.mno}>
          <td className="border p-1">{obj._id.mno}</td>
          <td className="border p-1 text-wrap">{obj._id.name}</td>
          <td className="border p-1">{obj._id.mainStock}</td>
        </tr>
      );
    });
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="0" />
        <h3 align="center">Medicine Threshold Report</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>
                <tr>
                  <th className="border p-1 font-weight-bold" width="150px">
                    Medicine #
                  </th>
                  <th className="border p-1 font-weight-bold" width="250px">
                    Name
                  </th>
                  <th className="border p-1 font-weight-bold" width="200px">
                    Main Stock
                  </th>
                </tr>
              </thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default MedicineReport;
